export default "__VITE_ASSET__2f189e13__"